import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import LogoHeader from "../../components/LogoHeader";
import Button from "../../components/Button";
import { LoadingContainer } from "../../containers/loadingContainer";
import "./styles.css";
import epfl from "../../../../static/images/epfl-2.png";

const HomeView = ({ onStartConnecting, isConnected, isConnectedToASession, isLoading, isEstablishingConnection, connectionQuality, onRetry }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isConnected) {
      console.log("Bypassing user check, comment this to apply");
      const userAllowed = true;

      if (userAllowed) {
        console.log("User allowed; connecting to server...");
        onStartConnecting();
      } else {
        alert("Sorry but the website is not operational right now...");
        window.location.href = "https://www.epfl.ch";
      }
    }
  }, [isConnected]);

  useEffect(() => {
    if (isConnectedToASession) {
      navigate("/app");
    }
  }, [isConnectedToASession]);

  if (isLoading) {
    return <LoadingContainer />;
  }

  return (
    <div className="home-container column">
      <video playsInline autoPlay muted loop className="hero-video">
        <source src="https://killcloud.nyc3.cdn.digitaloceanspaces.com/assets/xr.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="video-overlay"></div>

      <div className="home-content column">
        <LogoHeader direction="horizontal" />
        <p className="home-text">
          Immersive chemistry, materials and structural biology in mixed reality with real-time multi-user collaboration, interactive simulations, and an on-board AI assistant.
        </p>
        {connectionQuality?.status === "failed" ? (
          <div className="home-btn-row home-error column">
            <div className="home-error-header row">
              <svg className="home-error-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span className="home-error-title">Poor network connection</span>
            </div>
            <p className="home-error-msg">A stable connection is required for live collaboration. Please check your network and try again.</p>
            <Button variant="big" handleClick={onRetry}>Try again</Button>
          </div>
        ) : isEstablishingConnection ? (
          <div className="home-btn-row home-connecting">
            <div className="home-connecting-spinner"></div>
            <span>Connecting...</span>
          </div>
        ) : (
          <div className="home-btn-row row">
            <Link to="/create">
              <Button icon="plus" variant="big">Create</Button>
            </Link>
            <Link to="/join">
              <Button icon="users" variant="big" className="purple">Join session</Button>
            </Link>
          </div>
        )}
        <div className="home-footer row">
          <Link to="/about">
            <p className="home-link">About...</p>
          </Link>
          <div className="home-divider"></div>
          <Link to="https://killcloud.nyc3.cdn.digitaloceanspaces.com/scenes/mwxr_manual.pdf" target="_blank">
            <p className="home-link">Manual...</p>
          </Link>
          <div className="home-divider"></div>
          <p>© 2026 MolecularWebXR. All rights reserved. Part of the
        {" "}
        <a
          href="https://molecularweb.org"
          target="_blank"
          rel="noopener noreferrer"
          className="create-menu-text link"
        >Molecularweb.org</a>
        {" "}
        universe</p>
          <img className="home-epfl-logo" src={epfl}></img>
        </div>
      </div>
    </div>
  );
};

export default HomeView;
